import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocalstorageService } from './services/Common/localstorage.service';
import { HomePageService } from './services/home-page.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private _localStorageService: LocalstorageService, private route: ActivatedRoute, private _homePageService: HomePageService) {
  }

  ngOnInit() {
    this.route.queryParams.forEach(async (params: Params) => {
      var productCondition = params['productCondition'];
      
      if (productCondition) {
        await this._homePageService.setProductCondition(productCondition);
        var baseUrl = window.location.href.split('?')[0];
        window.history.pushState({}, document.title, baseUrl);
      }
      
      var searchKeyword = params['searchKeyword'];
      if (searchKeyword) {
        await this._localStorageService.setSearchBar(searchKeyword);
      } else {
        this._localStorageService.removeSearchBar();
      }
      var token = params['token'];
      var firstName = params['firstName'];
      var userType = params['userType'];
      var userId = params['userId'];
      if (params.token !== undefined) {
        await this._localStorageService.setToken(token);
        await this._localStorageService.setname(firstName);
        await this._localStorageService.setUserRole(userType);
        await this._localStorageService.setUserId(userId);
        var baseUrl = window.location.href.split('?')[0];
        var urlParams = baseUrl.split('#');
        window.history.pushState({}, document.title, "/#" + urlParams[1]);
      }
    });

  }
}